import React,{useEffect, useRef} from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { themeColor } from '../../util/themeLenses'

const SkipLink = styled.a`
  position: absolute;
    top: -60px;
    left: 0;
    background-color: ${themeColor('main')};
    color: white;
    width: 100%;
    padding: 8px 16px;
    z-index: 1000;
    font-weight: 600;
    text-decoration: none;
    transition: top 0.3s ease;
    text-align: center;

  &:focus,
  &:active {
    top: 0;
    outline: none;
    box-shadow: none;
  }
`

const SkipToContent = ({contentId, text = 'Saltar al contenido principal', autoFocus = true}) => {
    const divRef = useRef(null)
    useEffect(() => {
        autoFocus && divRef?.current?.focus()
    }, [autoFocus])

  return (
      <div ref={divRef} tabIndex={-1}>
          <SkipLink tabIndex='0' href={'#' + contentId}>
              {text}
          </SkipLink>
      </div>
  )
}

SkipToContent.propTypes = {
 contentId: PropTypes.string,
 text: PropTypes.string,
 autoFocus: PropTypes.boolean,
}

export default SkipToContent
